import React from "react"
import { Field, ErrorMessage } from "formik"

function KCInput(props) {
  const { name, className, inputClass, errorClass, label, isRequired = false, ...rest } = props
  return (
    <div className={className}>
      <label htmlFor={name}> {label}</label>
      <Field name={name} {...rest} className={inputClass} />
      {isRequired ? <span className="requiredField">*</span> : null}
      <span className={errorClass}><ErrorMessage name={name}/></span>
    </div>
  )
}
export default KCInput